import { render, staticRenderFns } from "./TraveldocMove.vue?vue&type=template&id=5571364c&"
import script from "./TraveldocMove.vue?vue&type=script&lang=js&"
export * from "./TraveldocMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports